module.exports = __webpack_public_path__ + "img/empty-waiter-red.39a331f.svg";